export default __webpack_public_path__ + "static/media/353.293ac0b6.gif";